var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutopalaceBuda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.469,
    height: 38.037,
    viewBox: "0 0 198.469 38.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-3070 -860)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(3070 860)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M24.084,18.841l-3.371-5.072H8.114l-3.3,5.072H0L12.168,1.266A2.678,2.678,0,0,1,14.448,0a2.746,2.746,0,0,1,2.311,1.243L28.675,18.837H24.084ZM14.326,4.667l-3.882,5.579h7.832l-3.95-5.579Z",
    transform: "translate(0 0)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M92.519,10.37V20.692a3.746,3.746,0,0,1-1.827,3.462q-1.825,1.1-5.96,1.1H80.145q-7.859,0-7.855-4.564V10.37h3.928V20.54c0,.843,1.239,1.27,3.725,1.27h5q3.626,0,3.626-1.243V10.37h3.958Z",
    transform: "translate(-44.724 -6.416)",
    fill: "#004687"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M131.064.86v3.9H128.81v3.2h2.254V19.373h3.928V7.96h5.983V4.742h-5.983V.86Z",
    transform: "translate(-79.692 -0.532)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(62.33 0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M183.235,20.507a3.972,3.972,0,0,1-.507,2.017,4.357,4.357,0,0,1-1.445,1.483,7.157,7.157,0,0,1-2.269.923,12.974,12.974,0,0,1-2.978.316h-5.1a12.968,12.968,0,0,1-3.028-.332,7.862,7.862,0,0,1-2.372-.938,4.578,4.578,0,0,1-1.533-1.483,3.7,3.7,0,0,1-.545-1.99V15.256a3.836,3.836,0,0,1,.557-2.029,4.916,4.916,0,0,1,1.56-1.548,8.119,8.119,0,0,1,2.372-.976,12.3,12.3,0,0,1,2.99-.343h5.1q7.2,0,7.2,4.843v5.3Zm-3.954-5.35a.779.779,0,0,0-.267-.561,2.125,2.125,0,0,0-.713-.419,5.916,5.916,0,0,0-1.049-.263,7.755,7.755,0,0,0-1.293-.1h-5a6.662,6.662,0,0,0-1.293.126,6.13,6.13,0,0,0-1.155.343,2.931,2.931,0,0,0-.835.5.8.8,0,0,0-.316.61v4.969a.727.727,0,0,0,.316.568,2.863,2.863,0,0,0,.835.458,7.057,7.057,0,0,0,1.178.305,7.731,7.731,0,0,0,1.316.114h4.946a5.819,5.819,0,0,0,1.117-.114,6.175,6.175,0,0,0,1.079-.305,2.708,2.708,0,0,0,.808-.458.744.744,0,0,0,.32-.568v-5.2Z",
    transform: "translate(-163.46 -6.509)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M242.419,7.49a4.2,4.2,0,0,1-2.067,3.8,11.216,11.216,0,0,1-5.922,1.293H223.7V19H219.62V.26h14.963a15.3,15.3,0,0,1,3.142.305,9.4,9.4,0,0,1,2.486.862,4.717,4.717,0,0,1,1.621,1.354,2.98,2.98,0,0,1,.58,1.815v2.89Zm-4.057-2.235a.786.786,0,0,0-.328-.606,2.82,2.82,0,0,0-.862-.48,6.586,6.586,0,0,0-1.2-.316,8.087,8.087,0,0,0-1.358-.114h-10.9v5.35h10.9q3.752,0,3.748-1.7V5.259Z",
    transform: "translate(-198.205 -0.26)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M291.746,10.37a10.83,10.83,0,0,1,2.787.332,6.615,6.615,0,0,1,2.1.938,4.226,4.226,0,0,1,1.323,1.483,4.3,4.3,0,0,1,.45,1.99v5.556q0,4.587-6.665,4.587h-7.459a10.546,10.546,0,0,1-2.685-.332,7.981,7.981,0,0,1-2.219-.911,4.7,4.7,0,0,1-1.495-1.407,3.241,3.241,0,0,1-.545-1.815V18.915a3.307,3.307,0,0,1,.511-1.838,4.022,4.022,0,0,1,1.411-1.331,7.381,7.381,0,0,1,2.17-.8,13.408,13.408,0,0,1,2.753-.267h10.238c0-.236-.2-.461-.6-.683a4.026,4.026,0,0,0-1.853-.328h-8.038v-3.3h7.813Zm-7.63,7.455c-1.9,0-2.841.5-2.841,1.495v1.167q0,1.321,2.917,1.319h7.859a9.1,9.1,0,0,0,1.3-.076,1.192,1.192,0,0,0,.747-.366,1.617,1.617,0,0,0,.324-.877,12.44,12.44,0,0,0,.076-1.6V17.825H284.112Z",
    transform: "translate(-233.915 -6.515)",
    fill: "#004687"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 4.084,
    height: 18.841,
    transform: "translate(128.684 0)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M367.689,10.37a10.768,10.768,0,0,1,2.787.332,6.583,6.583,0,0,1,2.109.938,4.131,4.131,0,0,1,1.316,1.483,4.209,4.209,0,0,1,.461,1.99v5.556q0,4.587-6.677,4.587h-7.447a10.658,10.658,0,0,1-2.7-.332,7.929,7.929,0,0,1-2.212-.911,4.813,4.813,0,0,1-1.5-1.407,3.234,3.234,0,0,1-.538-1.815V18.915a3.334,3.334,0,0,1,.5-1.838,4.041,4.041,0,0,1,1.426-1.331,7.316,7.316,0,0,1,2.166-.8,13.4,13.4,0,0,1,2.749-.267h10.246c0-.236-.2-.461-.606-.683a4.015,4.015,0,0,0-1.853-.328h-8.042v-3.3h7.809Zm-7.63,7.455c-1.888,0-2.837.5-2.837,1.495v1.167q0,1.321,2.913,1.319H368a9.04,9.04,0,0,0,1.3-.076,1.2,1.2,0,0,0,.755-.366,1.648,1.648,0,0,0,.328-.877,12.453,12.453,0,0,0,.076-1.6V17.825Z",
    transform: "translate(-218.574 -6.416)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M420.164,25.251c-2.673,0-4.595-.378-5.781-1.133a3.835,3.835,0,0,1-1.773-3.485V15q0-4.644,6.925-4.644h13.159v3.451H419.337c-1.865,0-2.788.37-2.788,1.113v5.552q0,1.316,3.725,1.319h12.42v3.447H420.168Z",
    transform: "translate(-255.274 -6.41)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M471.991,19.684q0,2.151,5.7,2.154h6.57v3.428h-7.817a15.809,15.809,0,0,1-3.722-.393,9.3,9.3,0,0,1-2.665-1.052,4.66,4.66,0,0,1-1.6-1.537,3.478,3.478,0,0,1-.534-1.834V15.2a3.71,3.71,0,0,1,.557-2.029,4.684,4.684,0,0,1,1.575-1.51,8.061,8.061,0,0,1,2.433-.949,13.941,13.941,0,0,1,3.169-.332h5.7a10.511,10.511,0,0,1,2.623.309,7.4,7.4,0,0,1,2.093.847,4.135,4.135,0,0,1,1.384,1.342,3.309,3.309,0,0,1,.5,1.788v5.022H471.991Zm12.118-4.667q0-1.27-3.2-1.27h-5.7q-3.375,0-3.371,1.243v1.571h12.275V15.013Z",
    transform: "translate(-289.499 -6.422)",
    fill: "#004687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M223.07,72.454v3.26h8.3c1.113,0,1.563-.255,1.563-1.075v-.82c0-1.094-.389-1.365-1.464-1.365h-8.4Zm0-5.213v3.066h8.32c1.033,0,1.365-.294,1.365-1.171V68.3c0-.8-.408-1.056-1.659-1.056ZM220.1,64.82H231.33c3.028,0,4.2.8,4.2,3.028v1.094c0,1.563-.606,2.128-1.445,2.364.957.194,1.621.8,1.621,2.772v1.171c0,2.109-1.155,2.89-4.179,2.89H220.1V64.82Z",
    transform: "translate(-136.172 -40.103)",
    fill: "#6884a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M269.469,82.582c-3.924,0-5.079-1.209-5.079-4.568V72h2.929v5.937c0,1.8.606,2.17,2.383,2.17h3.047c1.9,0,2.383-.37,2.383-2.17V72h2.89v6.013c0,3.359-1.152,4.568-5.117,4.568h-3.436Z",
    transform: "translate(-163.573 -44.545)",
    fill: "#6884a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M307.1,72.39c0,1.857.507,2.189,2.578,2.189h3.241c1.834,0,2.265-.408,2.265-2.166V68.954h-5.525c-2.052,0-2.559.294-2.559,2.185v1.247Zm2.208,4.648c-3.966,0-5.113-1.209-5.113-4.568V71.044c0-3.378,1.152-4.587,5.113-4.587h5.876V63.04h2.909v9.43c0,3.359-1.152,4.568-5.1,4.568H309.3Z",
    transform: "translate(-188.197 -39.002)",
    fill: "#6884a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M355.831,77.79h-7.52c-.683,0-1.094.233-1.094,1.072v.725c0,.744.45,1,1.19,1h5.468c1.369,0,1.952-.313,1.952-1.9v-.9ZM348.2,82.572c-3.047,0-3.867-1.075-3.867-2.791v-1c0-1.777.744-2.791,3.672-2.791h7.832v-.236c0-1.346-.507-1.7-1.8-1.7h-5.731V71.99h5.731c3.378,0,4.705,1.213,4.705,3.9v2.578c0,3.066-1.072,4.1-4.82,4.1H348.2Z",
    transform: "translate(-213.03 -44.539)",
    fill: "#6884a5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopalaceBuda);
export default __webpack_public_path__ + "static/media/autopalace-buda.f0d8dfa4e76bcbf49cfc242013217818.svg";
export { ForwardRef as ReactComponent };